exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nc-workbench-loading{height:100%}.nc-workbench-loading .wui-spin-full-screen{top:40px}.nc-workbench-loading .wui-spin-backdrop{z-index:390!important}", ""]);

// exports
